export default {
  saved: "Data was successfully saved",
  updated: "Data was successfully updated",
  deleted: "Data was successfully deleted",
  sent: "Request was successfully sent",
  error: "System error - Please contact the administrator",
};
